import { render, staticRenderFns } from "./PrivacyNotiMaker.vue?vue&type=template&id=8f0bb282&scoped=true"
import script from "./PrivacyNotiMaker.vue?vue&type=script&lang=js"
export * from "./PrivacyNotiMaker.vue?vue&type=script&lang=js"
import style0 from "./PrivacyNotiMaker.vue?vue&type=style&index=0&id=8f0bb282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0bb282",
  null
  
)

export default component.exports